import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function Products() {
  const navigate = useNavigate();
  const styles = {
    heroSection: {
      background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.9) 50%, rgba(71, 85, 105, 0.85) 100%), url("https://images.unsplash.com/photo-1542838132-92c53300491e?w=1600&q=80") center/cover',
      padding: '140px 0 100px',
      position: 'relative',
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center'
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'radial-gradient(ellipse at top right, rgba(59, 130, 246, 0.15) 0%, transparent 50%)',
      pointerEvents: 'none'
    },
    heroTitle: {
      fontSize: '3.5rem',
      fontWeight: 800,
      color: '#ffffff',
      marginBottom: '20px',
      textShadow: '0 4px 12px rgba(0,0,0,0.3)',
      letterSpacing: '-0.02em',
      fontFamily: "'DM Sans', sans-serif"
    },
    heroSubtitle: {
      fontSize: '1.25rem',
      color: '#e2e8f0',
      maxWidth: '700px',
      margin: '0 auto',
      lineHeight: 1.6,
      fontFamily: "'DM Sans', sans-serif"
    }
  };

  const products = [
    {
      category: 'Kalahari Foods Spices, Herbs, Seasoning Blends Products',
      items: ['Brown Onion Powder', 'Garlic Powder', 'Cayenne Pepper (Chili)', 'Paprika', 'BBQ & Multi Seasonings', 'Black Pepper', 'Herbs (Thyme, Parsley, etc.)']
    },
    {
      category: 'Kalahari Foods Dehydrated Fruits & Powders',
      items: ['Strawberries, Blueberries, Bananas, etc']
    },
    {
      category: 'Farm Fresh Vegetables & Fruits',
      items: []
    },
    {
      category: 'Meat Products',
      items: ['Pork Meat', 'Kalahari Foods Biltongs']
    },
    {
      category: 'Eggs & Beacons',
      items: []
    },
    {
      category: 'General trading commodities',
      items: []
    }
  ];

  const services = [
    {
      title: 'Product Sourcing & Procurement',
      description: 'We identify and source quality products tailored to your specifications and market requirements.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
        </svg>
      )
    },
    {
      title: 'Dehydrating & Blending',
      description: 'Fruits & vegetables processed to your required texture, flavor and grain size with precision.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a10 10 0 0 1 10 10"/><path d="M12 2a10 10 0 0 0-10 10"/><path d="M12 22a10 10 0 0 0 10-10"/><path d="M12 22a10 10 0 0 1-10-10"/><circle cx="12" cy="12" r="3"/>
        </svg>
      )
    },
    {
      title: 'Wholesale & Distribution',
      description: 'Efficient bulk supply and reliable delivery networks to get products where they need to be.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 17H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v3"/><rect width="13" height="10" x="9" y="11" rx="1"/><circle cx="11" cy="20" r="1"/><circle cx="19" cy="20" r="1"/>
        </svg>
      )
    },
    {
      title: 'Supplier Coordination',
      description: 'Seamless management of supplier relationships to ensure consistent quality and on-time delivery.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      )
    },
    {
      title: 'Market Linkage',
      description: 'Connecting buyers and sellers across borders to unlock new growth and trade opportunities.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/>
        </svg>
      )
    },
    {
      title: 'Trade Facilitation',
      description: 'Expert guidance through documentation, compliance, and logistics for smooth cross-border trade.',
      icon: (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" x2="8" y1="13" y2="13"/><line x1="16" x2="8" y1="17" y2="17"/><polyline points="10 9 9 9 8 9"/>
        </svg>
      )
    }
  ];



  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=DM+Sans:wght@400;500;600&display=swap');

        .service-card {
          transition: transform 0.3s ease;
          cursor: default;
        }
        .service-card:hover {
          transform: translateY(-6px) !important;
        }
        .service-card:hover .service-icon-circle {
          background: #2563eb !important;
        }
        .service-card:hover .service-icon-circle svg {
          stroke: #ffffff !important;
        }
        .service-number {
          font-family: 'Cormorant Garamond', serif;
          font-size: 0.75rem;
          font-weight: 600;
          color: #ffffff;
          line-height: 1;
        }
        .cta-btn {
          background: #2563eb;
          color: #fff;
          border: none;
          border-radius: 50px;
          padding: 18px 48px;
          font-family: 'DM Sans', sans-serif;
          font-size: 1rem;
          font-weight: 500;
          letter-spacing: 0.02em;
          cursor: pointer;
          transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
        }
        .cta-btn:hover {
          background: #1e40af;
          transform: translateY(-2px);
          box-shadow: 0 8px 30px rgba(37,99,235,0.4);
        }
      `}</style>

      {/* Hero Section */}
      <div style={styles.heroSection}>
        <div style={styles.heroOverlay}></div>
        <Container style={{ position: 'relative', zIndex: 2 }}>
          <Row>
            <Col className="text-center">
              <h1 style={styles.heroTitle}>Our Products & Services</h1>
              <p style={styles.heroSubtitle}>
                Quality products and reliable services tailored to meet your business needs
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Products Section */}
      <div style={{ padding: '80px 0', background: 'linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url("/images/manami-services.png") center/cover fixed' }}>
        <Container>
          <Row>
            <Col md={12}>
              <h2 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1e40af', marginBottom: '24px', textAlign: 'center', fontFamily: "'DM Sans', sans-serif" }}>Our Products</h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', color: '#475569', textAlign: 'center', maxWidth: '900px', margin: '0 auto 20px', fontFamily: "'DM Sans', sans-serif" }}>
                Manami Trading supplies a range of products tailored to market demand. Our offerings may include:
              </p>
              <p style={{ fontSize: '1rem', fontStyle: 'italic', color: '#64748b', textAlign: 'center', marginBottom: '60px', fontFamily: "'DM Sans', sans-serif" }}>
                Products can be customized based on customer needs and availability
              </p>
            </Col>
          </Row>

          <Row>
            {products.map((product, index) => (
              <Col md={6} lg={4} key={index} className="mb-4">
                <div style={{ 
                  background: 'rgba(255, 255, 255, 0.7)', 
                  backdropFilter: 'blur(10px)',
                  padding: '30px', 
                  borderRadius: '16px', 
                  height: '100%', 
                  boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 40px rgba(37, 99, 235, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.1)';
                }}>
                  <h4 style={{ color: '#2563eb', fontWeight: 600, fontSize: '1.2rem', marginBottom: '16px', fontFamily: "'DM Sans', sans-serif" }}>{product.category}</h4>
                  {product.items.length > 0 && (
                    <ul style={{ paddingLeft: '20px', margin: 0, color: '#64748b', lineHeight: '1.8', fontFamily: "'DM Sans', sans-serif" }}>
                      {product.items.map((item, idx) => (
                        <li key={idx} style={{ fontSize: '0.95rem' }}>{item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* ── Services Section ── */}
      <div style={{
        padding: '100px 0 120px',
        background: 'url("https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=1600&q=80") center/cover fixed',
        position: 'relative',
        fontFamily: "'DM Sans', sans-serif"
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(247, 246, 243, 0.85)',
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)'
        }}></div>
        <Container style={{ position: 'relative', zIndex: 1 }}>
          {/* Section label */}
          <Row>
            <Col className="text-center" style={{ marginBottom: '16px' }}>
              <span style={{
                display: 'inline-block',
                background: '#1e40af',
                color: '#ffffff',
                fontFamily: "'DM Sans', sans-serif",
                fontSize: '0.7rem',
                fontWeight: 600,
                letterSpacing: '0.18em',
                textTransform: 'uppercase',
                padding: '8px 22px',
                borderRadius: '4px'
              }}>
                OUR SERVICES
              </span>
            </Col>
          </Row>

          {/* Heading */}
          <Row>
            <Col className="text-center" style={{ marginBottom: '80px' }}>
              <h2 style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 'clamp(2.2rem, 4vw, 3.4rem)',
                fontWeight: 700,
                color: '#1a1a1a',
                letterSpacing: '-0.01em',
                lineHeight: 1.2,
                margin: 0
              }}>
                What We Do For You
              </h2>
            </Col>
          </Row>

          {/* Services — open layout, no boxes */}
          <Row className="justify-content-center" style={{ paddingBottom: '20px' }}>
            {services.map((service, index) => (
              <Col md={6} lg={4} xl={2} key={index} className="mb-5 d-flex justify-content-center">
                <div
                  className="service-card"
                  style={{
                    textAlign: 'center',
                    maxWidth: '280px'
                  }}
                >
                  {/* Icon circle + number badge */}
                  <div style={{ position: 'relative', display: 'inline-block', marginBottom: '22px' }}>
                    <div
                      className="service-icon-circle"
                      style={{
                        width: '90px',
                        height: '90px',
                        borderRadius: '50%',
                        background: '#dbeafe',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'background 0.3s ease',
                        color: '#2563eb'
                      }}
                    >
                      {service.icon}
                    </div>
                    <div style={{
                      position: 'absolute',
                      top: '-4px',
                      right: '-4px',
                      width: '28px',
                      height: '28px',
                      borderRadius: '50%',
                      background: '#2563eb',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 3px 10px rgba(37,99,235,0.4)'
                    }}>
                      <span className="service-number">
                        {String(index + 1).padStart(2, '0')}
                      </span>
                    </div>
                  </div>

                  {/* Title */}
                  <h4 style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: '1.3rem',
                    fontWeight: 700,
                    color: '#1a1a1a',
                    marginBottom: '10px',
                    lineHeight: 1.3
                  }}>
                    {service.title}
                  </h4>

                  {/* Description */}
                  <p style={{
                    fontSize: '0.9rem',
                    lineHeight: '1.75',
                    color: '#6b7280',
                    margin: 0,
                    fontFamily: "'DM Sans', sans-serif"
                  }}>
                    {service.description}
                  </p>
                </div>
              </Col>
            ))}
          </Row>

          {/* CTA Button */}
          <Row style={{ marginTop: '60px' }}>
            <Col className="text-center">
              <button className="cta-btn" onClick={() => navigate('/contact')}>
                Get In Touch With Us
              </button>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Products;